export const BuyerSteps = [
  {
    text: 'steper_main.steps.step_1',
  },
  {
    text: 'steper_main.steps.step_2',
  },
  {
    text: 'steper_main.steps.step_3',
  },
  {
    text: 'steper_main.steps.step_4',
  },
  {
    text: 'steper_main.steps.step_5',
  },
  {
    text: 'steper_main.steps.step_6',
  },
]


export const DetailedSteps = [
  {
    label: 'stepper.steps.step_1.text',
    mirror: false,
    descriptions: [
      {
        text: 'stepper.steps.step_1.descriptions.text_1',
        mirror: false,
      },
      {
        text: 'stepper.steps.step_1.descriptions.text_2',
        mirror: true,
      },
    ],
  },
  {
    label: 'stepper.steps.step_2.text',
    mirror: true,
    descriptions: [
      {
        text: 'stepper.steps.step_2.descriptions.text_1',
        mirror: false,
      },
      {
        text: 'stepper.steps.step_2.descriptions.text_2',
        mirror: false,
      },
      {
        text: 'stepper.steps.step_2.descriptions.text_3',
        mirror: true,
      },
    ],
  },
  {
    label: 'stepper.steps.step_3.text',
    mirror: false,
    descriptions: [
      {
        text: 'stepper.steps.step_3.descriptions.text_1',
        mirror: false,
      },
      {
        text: 'stepper.steps.step_3.descriptions.text_2',
        mirror: true,
      },
    ],
  },
  {
    label: 'stepper.steps.step_4.text',
    mirror: false,
    descriptions: [
      {
        text: 'stepper.steps.step_4.descriptions.text_1',
        mirror: true,
      },
      {
        text: 'stepper.steps.step_4.descriptions.text_2',
        mirror: true,
      },
      {
        text: 'stepper.steps.step_4.descriptions.text_3',
        mirror: false,
      },
      {
        text: 'stepper.steps.step_4.descriptions.text_4',
        mirror: true,
      },
    ],
  },
  {
    label: 'stepper.steps.step_5.text',
    mirror: false,
    descriptions: [
      {
        text: 'stepper.steps.step_5.descriptions.text_1',
        mirror: true,
      },
      {
        text: 'stepper.steps.step_5.descriptions.text_2',
        mirror: false,
      },
      {
        text: 'stepper.steps.step_5.descriptions.text_3',
        mirror: true,
      },
    ],
  },
  {
    label: 'stepper.steps.step_6.text',
    mirror: false,
    descriptions: [
      {
        text: 'stepper.steps.step_6.descriptions.text_1',
        mirror: false,
      },
      {
        text: 'stepper.steps.step_6.descriptions.text_2',
        mirror: false,
      },
      {
        text: 'stepper.steps.step_6.descriptions.text_3',
        mirror: false,
      },
      {
        text: 'stepper.steps.step_6.descriptions.text_4',
        mirror: false,
      },
    ],
  },
]
